export enum GlGroupEnum {
  SALE = 'SALE',
  PURCHASE = 'PURCHASE',
  OTHER = 'OTHER',
}
